export const GATEWAYS = {
  PAGARME: "Pagar.me",
  IUGU: "Iugu",
  PAYPAL: "PayPal",
  EBANX: "EBANX",
  WORLDPAY: "Worldpay",
  CIELO: "Cielo",
  PIX: "Pix",
  STRIPE: "Stripe",
  MERCADOPAGO: "Mercado Pago",
  ASAAS: "Asaas",
  DLOCAL: "DLocal",
  EFI: "Efi",
};

export function getGateway(gateway) {
  if (!gateway) return "";

  return GATEWAYS[gateway] || gateway;
}

export function getGatewayList() {
  return Object.entries(GATEWAYS).map(([id, name]) => ({ id, name }));
}